module.exports = __webpack_public_path__ + "img/change-card-3-2.svg";